export default `
  mutation CreatePaymentIntent($input: CreatePaymentIntentInput) {
    createPaymentIntent(input: $input) {
      clientSecret
    }
  }
`;
